import { GridValidRowModel } from "@mui/x-data-grid";


export type Role = "admin"| "customeradmin"| "customeruser"| "groundstaff";

// Customer user routes
const CUSTOMER_USER_ROUTES: readonly string[] = [
  "/tracking-management",
  "/subscription-template",
  "/oceancsvbulkupload",
  "/trackingDetail",
  "/oceanTrackingDetail",
  "/manage-profile",
  "/manage-contact",
  "/document_automation",
  "/tracking-simulator",
  "/manage-communication",
  "/csvbulkupload",
  "/dashboard-widgets-graph",
  "/report",
];

// ACL Route Mapping
export const ACL_ROUTE: Record<Role, readonly string[]> = {
  admin: [
    "/manage-users",
    "/add-organization",
    "/manage-credits",
    "/communication-errors",
    "/failed-tracking"
  ],

  customeruser: CUSTOMER_USER_ROUTES,

  customeradmin: [
    ...CUSTOMER_USER_ROUTES, 
    "/manage-users",
    "/manage-credits",
    "/manage-teams",
    "/archive-management",
    "/milestone-management",
    "/manage-milestone-grouping",
    "/manage-flags",
    "/manage-custom-fields",
    "/usage-metrics",
    "/communication-template",
    "/communication-errors"
  ],

  groundstaff: [
    "/tracking-management",
  ],
};
export const preventAddingDuplocateRow = (
  rows: any[] | readonly GridValidRowModel[]
) => {
  let obj = rows?.[0];

  let preventDoubleClick = true;
  for (let key in obj) {
    if (obj[key] === "" || obj[key] === undefined) {
      preventDoubleClick = false;
    }
  }

  return preventDoubleClick;
};

export const hideToggleButton = (rows: any, id: string) => {
  let array = [...rows];
  let updateRowIndex = rows?.findIndex((row: any) => row.id === id);
  if (updateRowIndex !== -1) {
    array[updateRowIndex].ishideToggle = false;
  }

  return array;
};

export const hideToggleButtonEditMode = (rows: any, updatedRow: any) => {
  let array = [...rows];

  let findIndex = array.findIndex((item: any) => item?._id === updatedRow?._id);
  if (findIndex !== -1) {
    array[findIndex].ishideToggle = false;
  }

  return array;
};




interface ACLContext {
  role: Role;
  isWebhookAllowed?: boolean;
}

export const getAllowedRoutes = ({
  role,
  isWebhookAllowed,
}: ACLContext): string[] => {
 
  let routes = [...(ACL_ROUTE[role] || [])];

  // ✅ Conditional Webhook Access
  if (role === "customeradmin" && isWebhookAllowed) {
    routes.push("/milestone-webhooks");
  }
  return routes;
};
